var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Save(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.33 13H13v50h50V25.67L51.33 13zM40 58H25v-4h15v4zm9-8H25v-4h24v4zm1-10H25V17h15v15h4V17h6v23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Save.fe6a7dea.svg";
export { SvgJ2Save as ReactComponent };